<template>
  <div class="mx-auto my-[72px] max-w-3xl px-6">
    <h1
      class="mb-[43px] border-b border-b-gpx_gray-800 pb-[17px] text-gpx_2xl font-semibold text-gpx_black-500"
    >
      Edit Shipment
    </h1>
    <ShipmentEditForm :key="String($route.params.id)" />
  </div>
</template>

<script setup lang="ts">
import ShipmentEditForm from '@/components/shipment/edit/ShipmentEditForm.vue';
import { setTitle } from '@/utils/title';
import { onMounted } from 'vue';
import * as events from '@/events';

setTitle('Edit Shipment');
onMounted(() => {
  events.trigger(events.names.GEOFENCE_LIST_VIEWED);
});
</script>
